import su from './sub.module.scss';

export default function SubmitBtn({ label, disabled = false, onClick }) {
  return (
    <>
      <input type="submit" disabled={disabled} onClick={onClick} className={su.in} value={label} />
    </>
  );
}
